/* =========================================================================
   Faceting — theme behaviour
   Much smaller than the static site's: Shopify now owns the catalogue,
   the filtering and the cart, so all that remains is the mobile menu.
   ========================================================================= */
(function () {
  'use strict';

  var toggle = document.querySelector('[data-nav-toggle]');
  var panel = document.getElementById('mobile-nav');
  if (!toggle || !panel) return;

  /* `hidden` is an HTMLElement property — assigning it on an <svg> only sets
     a JS expando and never reaches the attribute, so toggle the attribute. */
  function setHidden(el, on) {
    if (!el) return;
    if (on) el.setAttribute('hidden', ''); else el.removeAttribute('hidden');
  }

  function setOpen(open) {
    panel.classList.toggle('is-open', open);
    toggle.setAttribute('aria-expanded', String(open));
    toggle.setAttribute('aria-label', open ? 'Close menu' : 'Menu');
    setHidden(toggle.querySelector('.nav-toggle__open'), open);
    setHidden(toggle.querySelector('.nav-toggle__close'), !open);
  }

  toggle.addEventListener('click', function () {
    setOpen(!panel.classList.contains('is-open'));
  });
  panel.addEventListener('click', function (e) {
    if (e.target.tagName === 'A') setOpen(false);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && panel.classList.contains('is-open')) {
      setOpen(false);
      toggle.focus();
    }
  });
})();
